module.exports = __webpack_public_path__ + "static/media/site-bienvenue.742a2c32.glb";